import { repositoryName } from '../slicemachine.config.json';
import * as prismic from '@prismicio/client';
import { useGlobal } from './states';
const client = prismic.createClient(repositoryName);

export const useFetchGlobalData = async () => {
  const global = useGlobal();

  await callOnce(async () => {
    const date = new Date();
    const year = date.getFullYear();
    const shortYear = [...year.toString()].slice(2, 4).join('');

    try {
      const globalResponse = await client.getSingle('global');
      const { data } = globalResponse;

      globalResponse.data.site_title =
        globalResponse.data.site_title?.split('+');

      const globalData = { ...data, year, shortYear };

      global.value = globalData;
    } catch (error) {
      global.value = null;
    }
    return { global };
  });
};
